import React from "react";
import moment from "moment";
import Info from "../../../assets/icons/info.svg";

function displayRejectDetails(reason, other) {
  return reason !== "Other (please state)" ? reason : other;
}

/**
 * Columns for prescription/pharmacy notifications DataTable.
 */
export function getPrescriptionNotificationColumns() {
  return [
    {
      id: "description",
      accessorKey: "description",
      header: "Description",
      cell: ({ row }) => (
        <span
          className="text-wrap font-size-16"
          data-testid={`notifications-row-description-${row.original?.id}`}
        >
          {row.original?.description ?? "—"}
        </span>
      ),
    },
    {
      id: "patient_name",
      accessorKey: "patient_name",
      header: "Patient",
      cell: ({ row }) => (
        <span
          className="text-wrap font-size-16"
          data-testid={`notifications-row-patient-${row.original?.id}`}
        >
          {row.original?.patient_name ?? "—"}
        </span>
      ),
      meta: { align: "left" },
    },
    {
      id: "datetime_sent",
      accessorKey: "datetime_sent",
      header: "Date",
      cell: ({ row }) => (
        <span
          className="font-size-16"
          data-testid={`notifications-row-date-${row.original?.id}`}
        >
          {row.original?.datetime_sent
            ? moment(row.original.datetime_sent).format("DD / MM / YYYY")
            : "—"}
        </span>
      ),
      meta: { align: "left" },
    },
    {
      id: "status",
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => {
        const status = row.original?.status;
        const id = row.original?.id;
        return (
          <div
            className="flex flex-wrap items-center justify-center gap-1 text-[#E41818]"
            data-testid={`notifications-row-status-${id}`}
          >
            <span data-testid={`notifications-row-status-value-${id}`}>
              {status ?? "—"}
            </span>
            {status === "Rejected" && (
              <div
                className="group relative inline-flex"
                data-testid={`notifications-row-reject-info-${id}`}
              >
                <img
                  src={Info}
                  alt=""
                  className="ml-1 h-4 w-4 shrink-0 cursor-pointer"
                  data-testid={`notifications-row-reject-info-icon-${id}`}
                />
                <span
                  className="pointer-events-none invisible absolute left-1/2 top-full z-20 mt-2 w-max max-w-md -translate-x-1/2 rounded-md bg-white px-5 py-2.5 text-center text-sm font-normal text-[#505050] shadow-[0_4px_20px_rgba(0,0,0,0.1)] group-hover:visible"
                  data-testid={`notifications-row-reject-tooltip-${id}`}
                >
                  {displayRejectDetails(
                    row.original?.rejection_reason,
                    row.original?.rejection_reason_other
                  )}
                </span>
              </div>
            )}
          </div>
        );
      },
      meta: { align: "center" },
    },
  ];
}

/**
 * Columns for general (admin) notifications DataTable.
 */
export function getAdminNotificationColumns() {
  return [
    {
      id: "title",
      accessorKey: "title",
      header: "Title",
      cell: ({ row }) => (
        <span
          className="font-size-16"
          data-testid={`notifications-admin-row-title-${row.original?.id}`}
        >
          {row.original?.title ?? "—"}
        </span>
      ),
    },
    {
      id: "description",
      accessorKey: "description",
      header: "Description",
      cell: ({ row }) => {
        const desc = row.original?.description ?? "";
        const short =
          desc.length > 80 ? `${desc.substring(0, 80)}...` : desc;
        const wide = desc.length > 40;
        const id = row.original?.id;
        return (
          <div
            className="font-size-16"
            data-testid={`notifications-admin-row-description-${id}`}
          >
            <div className="group relative inline-block max-w-full">
              <div
                className="pl-4"
                data-testid={`notifications-admin-row-description-short-${id}`}
              >
                {short}
              </div>
              <span
                className={`pointer-events-none invisible absolute top-full z-20 mt-1 rounded-md bg-white p-2.5 text-left text-sm text-[#505050] shadow-[0_4px_20px_rgba(0,0,0,0.1)] group-hover:visible ${wide ? "left-0 w-[550px] max-w-[90vw]" : "left-0 w-auto"
                  }`}
                data-testid={`notifications-admin-row-description-tooltip-${id}`}
              >
                {desc}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      id: "datetime_sent",
      accessorKey: "datetime_sent",
      header: "Date",
      cell: ({ row }) => (
        <span
          className="font-size-16"
          data-testid={`notifications-admin-row-date-${row.original?.id}`}
        >
          {row.original?.datetime_sent
            ? moment(row.original.datetime_sent).format("DD / MM / YYYY")
            : "—"}
        </span>
      ),
      meta: { align: "left" },
    },
  ];
}
